<template>
	<c-dialog ref="dialog" title="数据看板指标" width="850" height="550" @resolve="submitHandle">
		<div class="metric-config flex">
			<dl class="flex-grow">
				<dt class="flex-between-center"><p>已选项</p><span>拖动可进行排序</span></dt>
				<dd>
					<c-drag-sort v-model="selectedList" class="metric-list flex-wrap">
						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="metric-item flex-center-cross z-selected">
								<p class="ellipsis flex-grow">{{item.name}}</p>
								<a @click="removeMetric(index)"><i class="c-icon-cross"></i></a>
							</c-drag-item>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<div class="line"></div>
			<dl class="flex-grow">
				<dt class="flex-between-center"><p>待选项</p><span>点击添加到已选列表</span></dt>
				<dd><ul class="metric-list flex-wrap"><li v-for="item in availableList" :key="item.code" class="metric-item flex-center-cross" @click="addMetric(item)"><p class="ellipsis">{{item.name}}</p></li></ul></dd>
			</dl>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return { selectedList: [], availableList: [] }
		},
		methods: {
			open() {
				this.$refs.dialog.open();
				this.request({
					url: '/workbench/board/config', data: {},
					success: data => {
						this.selectedList = data.selected_list || [];
						this.availableList = data.available_list || [];
					}
				});
			},
			removeMetric(index) {
				this.availableList.push(this.selectedList.splice(index, 1)[0]);
			},
			addMetric(item) {
				this.selectedList.push(item);
				this.availableList = this.availableList.filter(metric => metric.code !== item.code);
			},
			submitHandle(stop, next) {
				stop();
				const metricCodes = this.selectedList.map(item => item.code).join(',');
				if (!metricCodes) {
					this.$message({message: '请至少配置一项指标', type: 'warn'});
					return;
				}
				this.request({
					url: '/workbench/board/config/edit', data: {metric_codes: metricCodes}, loading: true,
					success: () => {
						next();
						this.$message({message: '保存成功'});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.metric-config {
        height: 100%;
    }
	dl {
        height: 100%;
    }
	dt {
        height: 36px;
        padding: 0 12px 0 16px;
        background: #FAFAFA;
        span {
            font-size: 12px;
            color: #666;
        }
    }
	dd {
        padding: 12px 14px;
    }
	.metric-list {
        gap: 10px;
    }
	.metric-item {
        box-sizing: border-box;
		width: calc((100% - 20px) / 3);
        height: 35px;
        padding: 0 8px 0 12px;
        font-size: 13px;
        background: #F5F5F5;
        cursor: pointer;
        &:not(.z-selected):hover {
            color: #fff;
            background: var(--color-main);
        }
        &.z-selected {
            color: var(--color-main);
            background: #eef2ff;
            a {
                padding: 4px;
				color: #999;
                &:hover {
                    color: #FF414A;
                }
            }
        }
    }
	.line {
        width: 6px;
        border: 1px solid #ddd;
        border-width: 0 1px;
        background: #F9F9F9;
    }
</style>
